import React , {useState , useCallback , useEffect} from "react"
import Header from "../../../Layouts/Components/Header";
import {Box , Grid , Typography } from "@mui/material"
import MatchingSection from "./MatchingSection";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../shared/CustomButton";
import ScreenLoader from "../../shared/ScreenLoader";
import { Modal } from '@mui/material'
import ModalAlerts from '../../shared/DeleteModal';
import useSnackBar from "../../Hooks/useSnackBar";
import { useSelector , useDispatch } from "react-redux";
import { getRules  ,getMessageTypes  ,DeleteRules } from "../state/matchingAction";
import { Rule } from "@mui/icons-material";

const MatchingRules = () => {
  
  const dispatch = useDispatch()
  const [openDeleteModal,setOpenDeleteModal] = useState(false)
  const [RuleId,setRuleId]= useState(null)
  const { success, error, snackbar } = useSnackBar();
  const loadRules = useCallback (() =>dispatch(getRules(error)),[dispatch,error])
  const loadMessageType = useCallback(() => dispatch(getMessageTypes(error)), [error,dispatch]);

  const { Rules , messageTypes , loadAllRules  } = useSelector((state) => state.matchingRules);
const navigate = useNavigate()
 
useEffect(() => {
  loadMessageType()

  loadRules()
 
},[loadRules ,loadMessageType])

  const handleDelete = (Rule) => {

    setRuleId(Rule.id)
    setOpenDeleteModal(true)
  }

  const DeleteRule = () => {
      

    dispatch(DeleteRules(RuleId,error,success)).then(()=> {
      dispatch(getRules())
      setOpenDeleteModal(false)
    })

   }
  const handleEdit = (Rule) => {
    
navigate(`/rules/${Rule.id}`)
  }
  const matchingMenu = [
    {
      id: 1,
      action: "Delete",
      handler: handleDelete,
    },
    {
      id:2,
      action:"Edit",
      handler: handleEdit
    }
  ];

  const SetCloseDeleteModal = () => {
    setOpenDeleteModal(false)
  }

  return (
    <>
    {snackbar}

    <Header headLine="Matching rules">
    
      </Header>

    { messageTypes.length >= 0 && loadAllRules ?
     <ScreenLoader/> : messageTypes.length >= 0 && Rules.length <= 0 ?  <div style={{ marginTop: "10%" }}>
     <Box  sx={{display:'flex',justifyContent:"center" ,marginBottom:"5px"}}>
       <Typography sx={{color:"#50566E" , fontSize:"18px" , margin:"10px 0",fontWeight:"550"}}>  You haven’t created any matching rules yet</Typography>
     </Box>
     <Box sx={{display:'flex',justifyContent:"center"}}>
  
       <CustomButton text="Create New Rule"  type="add" action={() => {
        navigate('/rules/add-rule')

      }}/>
     </Box>
   </div> :
    <>
<Modal
  open={openDeleteModal}
  handleClose={() => SetCloseDeleteModal()}
>
<ModalAlerts
 title="Permenantly Delete Rule"
 btnTitle="Delete Rule"
 content={
  "Are you sure you want to delete Rule? data will no longer be restored."
}
handleCloseModal={() => SetCloseDeleteModal()}
action={DeleteRule}
/>
</Modal>



      <Header headLine="Matching rules">
      <CustomButton text="Create New Rule"  type="add" action={() => {
        navigate('/rules/add-rule')
        

      }}/>
      </Header>
      <Box
        sx={{
          backgroundColor: "#F8FAFB",
          paddingLeft: "30px",
          paddingTop: "50px",
          paddingBottom: "30px",
        }}
      >
        <Grid container sx={{ marginBottom: "50px" }}>
          <Grid item xs={8}>    
        { Rules && Rules.map((rule,index) => {
          return (
            <MatchingSection
             Rule={rule}
            key={rule.id}
            menu={matchingMenu}
             />
          );
        })}
          </Grid>
        </Grid>
      </Box>
    </> 
}
   </>
  );
};

export default MatchingRules;
